import { render, staticRenderFns } from "./LoginBusiness.vue?vue&type=template&id=4ce5020e&scoped=true&"
import script from "./LoginBusiness.vue?vue&type=script&lang=js&"
export * from "./LoginBusiness.vue?vue&type=script&lang=js&"
import style0 from "./LoginBusiness.vue?vue&type=style&index=0&id=4ce5020e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce5020e",
  null
  
)

export default component.exports